import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ClockIcon } from "../../../../assets/icons";
import { EmployeeExpenseReportsSummaryDTO } from "../../../../models/employee-expense-reports-summary/employee-expense-reports-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const MyTravelAndExpenseInProgressLink = ({
  customSummary,
  loading,
}: {
  customSummary: EmployeeExpenseReportsSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_travel_and_expenses.in_progress";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      title={`${t(`${tRP}.title`)}`}
      mainInfo={customSummary?.inProgressExpenseReports?.toString() ?? "0"}
      description={`${t(`${tRP}.reports`)}`}
      Icon={ClockIcon}
      IconStyle={{
        color: theme.palette.error.main,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
    />
  );
};
export default MyTravelAndExpenseInProgressLink;
